import { useTexts } from '../../../../contexts/TextsContext';
import { useData } from '../../../../contexts/DataContext';
import SectionTitle from '../shared/sectionTitle/SectionTitle';
import ActivityCard from './activityCard/ActivityCard';
import classes from './activities.module.scss';

const Activities = () => {
    const texts = useTexts();
    const { activities } = useData();

    return (
        <section className={classes.Activities} id="activities" aria-labelledby="activities-heading">
            <div className={classes.Inner}>
                <SectionTitle
                    id="activities-heading"
                    primaryText={texts.activitiesHeadingAccent}
                    secondaryText={texts.activitiesHeadingMain}
                />
                <div className={classes.List}>
                    {activities.map((activity, index) => (
                        <ActivityCard key={activity.id} activity={activity} isImageRight={index % 2 === 0} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Activities;
